// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"MedicalEventsDocumentsModal_buttonsContainer__Vaf8a"};